import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Paper, Stack, Chip } from '@mui/material';
import { login } from '../services/authService.ts';

const LoginPage: React.FC = () => {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit: React.FormEventHandler<HTMLFormElement> = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      // folosim hard redirect ca să evităm orice stare reziduală după StrictMode
      window.location.href = '/dashboard';
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Login failed');
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        px: 2,
        background: 'radial-gradient(circle at top, rgba(99,102,241,0.16), transparent 36%), linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
      }}
    >
      <Paper sx={{ width: '100%', maxWidth: 980, overflow: 'hidden', borderRadius: 4 }} elevation={8}>
        <Stack direction={{ xs: 'column', md: 'row' }}>
          <Box sx={{ flex: 1, p: 5, background: 'linear-gradient(135deg, #0f172a 0%, #1d4ed8 100%)', color: '#fff' }}>
            <Stack spacing={2}>
              <Chip label="Internal only" size="small" sx={{ width: 'fit-content', bgcolor: 'rgba(255,255,255,0.12)', color: '#fff' }} />
              <Typography variant="h3" component="h1" sx={{ fontWeight: 700, lineHeight: 1.05 }}>
                Internal control surface for 3100.
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.8)', maxWidth: 420 }}>
                Support, audit and cross-tenant operations stay here. Tenant staff use 3000.
              </Typography>
            </Stack>
          </Box>
          <Box sx={{ flex: 1, p: 5, bgcolor: '#fff' }}>
            <Typography variant="h5" gutterBottom>
              Sign in
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              Use an internal `SUPER_ADMIN` or `SUPPORT_AGENT` account to access 3100.
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email"
                margin="normal"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <TextField
                fullWidth
                label="Password"
                margin="normal"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {error && (
                <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                  {error}
                </Typography>
              )}
              <Button fullWidth type="submit" variant="contained" sx={{ mt: 3, py: 1.2 }}>
                Login
              </Button>
            </form>
          </Box>
        </Stack>
      </Paper>
    </Box>
  );
};

export default LoginPage;
